<template>
  <a-drawer
    class="part drawer project"
    height="80%"
    title="New Project"
    placement="bottom"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <div class="container inner">
      <ProjectForm :visible="visible" @submit="onSubmit" />
    </div>
    <!-- {{ customer }} -->
  </a-drawer>
</template>
<script>
import { ProjectForm } from '@/components/reno/forms'

const KEY = 'CREATE_PROJECT'

export default {
  components: {
    ProjectForm,
  },
  name: 'create-customer-drawer',
  data() {
    return {}
  },
  computed: {
    customer() {
      return this.$store.getters['crm/customer']
    },
    visible: {
      get() {
        return this.$store.getters['pm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.commit('pm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async onSubmit(valid_project) {
      if (valid_project) {
        const project_created = await this.$store.dispatch('pm/createProject', valid_project)
        this.onClose()
        // re-fetch the project list
        this.$store.dispatch('pm/fetchProjects')
      }
    },
    afterVisibleChange(val) {},
    showDrawer() {
      this.$store.dispatch('pm/open', KEY)
    },
    onClose() {
      this.$store.dispatch('pm/close', KEY)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer.project-task {
  .inner {
  }
}
</style>
